// extracted by mini-css-extract-plugin
export default {"card":"BillingCapacityDetails_card__wHst-","facts":"BillingCapacityDetails_facts__hNVVD","row":"BillingCapacityDetails_row__lUyuF","actions":"BillingCapacityDetails_actions__sTDKZ"};